export class Point {
    constructor(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.targetDist = Infinity;
        this.previousNode = undefined;
        this.close = false;
        this.colleague = []
        this.LocationName = undefined
        this.Category = undefined
        this.type = undefined
        this.LeaseType = undefined
        this.logo = {}
        this.elementTag = undefined
        this.color = undefined
        this.Description = undefined
        this.shape = undefined
        this.up = false;
        this.down = false;
        this.brand_Id = null;
        this.floorBash = false;
        this.extra = {}
    }
    addColleague(point) {
        this.colleague.push(point)
    }

    // storkeRect(w, h, i) {
    //     return <rect key={i} x={this.x * w} y={this.y * h} width={h} height={w} />
    // }
    // Circle(x, y, w, h, s = "yellow", PointDefineAction) {
    //     return <circle cx={x * w + w / 2} cy={y * h + h / 2} stroke={s} r={w / 2} onClick={() => PointDefineAction({ x: this.x, y: this.y, z: this.z })} style={{ cursor: "pointer" }} />
    // }
    // Text(x, y, w, h, text, style = {}) {
    //     return <text x={x * w + w / 2} y={y * h + h / 2} style={{ ...style,pointerEvents:"none" }}>{text}</text>
    // }
}